/* Useit Maison — effects & games (no dependencies). Each block is switched off in
   Theme settings → Effets & jeux, or by removing its section/block. */
(function () {
  'use strict';

  var fx = (window.theme && window.theme.fx) || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2);
    var comma = n.replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
      if (t === 'amount_no_decimals' || t === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return t.indexOf('comma') > -1 ? comma : n;
    });
  }
  function pick(list) { return list[Math.floor(Math.random() * list.length)]; }
  function toast(msg) { if (window.UseitCart) window.UseitCart.toast(msg); }
  function hexIn(str) { var m = String(str || '').match(/#([0-9a-f]{6}|[0-9a-f]{3})\b/i); return m ? m[0] : null; }

  /* ------------------------------------------------ Salam: terms before paying */
  var salamOK = false;
  try { salamOK = sessionStorage.getItem('useit-salam') === '1'; } catch (e) {}
  function salamSync() {
    var boxes = $$('[data-salam-check]');
    if (!boxes.length) return;
    boxes.forEach(function (b) { if (salamOK) b.checked = true; if (b.checked) salamOK = true; });
    $$('[data-checkout-btn]').forEach(function (btn) { btn.disabled = !salamOK; btn.classList.toggle('is-locked', !salamOK); });
    $$('[data-express], [data-salam-lockable]').forEach(function (el) { el.classList.toggle('is-salam-locked', !salamOK); });
  }
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-salam-check]');
    if (!box) return;
    salamOK = box.checked;
    try { sessionStorage.setItem('useit-salam', salamOK ? '1' : '0'); } catch (err) {}
    salamSync();
    var dl = $('[data-salam-consent] [data-delivery-dates]');
    var attrs = salamOK ? {
      'Conditions acceptées': 'Vente salam : prix payé intégralement à la commande, montre conforme à la description, livraison ' + (dl ? dl.textContent : 'au plus tard dans le délai annoncé'),
      'Livraison au plus tard': dl && dl.getAttribute('data-iso') ? dl.getAttribute('data-iso') : ''
    } : { 'Conditions acceptées': '', 'Livraison au plus tard': '' };
    fetch(((window.theme && window.theme.routes.cart) || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-salam-open]'), d = document.getElementById('SalamTerms');
    if (o && d) { e.preventDefault(); if (d.showModal) d.showModal(); else d.setAttribute('open', ''); return; }
    if (d && (e.target.closest('[data-salam-close]') || e.target === d)) { d.close ? d.close() : d.removeAttribute('open'); }
  });
  window.UseitSalam = salamSync;
  salamSync();

  /* ------------------------------------------------------------ Duo boxes */
  $$('[data-bundle-root]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-bundle-tab]');
      if (tab) {
        var id = tab.getAttribute('data-bundle-tab');
        $$('[data-bundle-tab]', root).forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        $$('[data-bundle]', root).forEach(function (d) { d.hidden = d.getAttribute('data-bundle-id') !== id; });
      }
    });
    $$('[data-bundle]', root).forEach(function (duo) {
      var pct = parseInt(duo.getAttribute('data-pct'), 10) || 0;
      var inputs = $$('[data-bundle-id-input]', duo);
      var add = $('[data-bundle-add]', duo);
      var free = parseInt(duo.getAttribute('data-free'), 10) || 0;
      function total() {
        var prices = inputs.map(function (inp) { return parseInt(inp.getAttribute('data-price'), 10) || 0; });
        var full = prices.reduce(function (s, x) { return s + x; }, 0), net = full;
        if (free > 0) {
          // offer « X achetées = Y offertes »: Shopify makes the cheapest ones free
          prices.slice().sort(function (x, y) { return x - y; }).slice(0, free).forEach(function (x) { net -= x; });
        } else if (prices.length > 1) {
          net = full - prices[1] + Math.round(prices[1] * (100 - pct) / 100);
        }
        $('[data-bundle-total]', duo).textContent = money(net);
        $('[data-bundle-full]', duo).textContent = (pct || free) ? money(full) : '';
      }
      $$('[data-bundle-pick]', duo).forEach(function (pick, i) {
        pick.addEventListener('click', function (e) {
          var sw = e.target.closest('.swatch');
          if (!sw || sw.disabled) return;
          $$('.swatch', pick).forEach(function (x) { x.classList.toggle('is-active', x === sw); x.setAttribute('aria-checked', x === sw ? 'true' : 'false'); });
          inputs[i].value = sw.getAttribute('data-id');
          inputs[i].setAttribute('data-price', sw.getAttribute('data-price'));
          var label = $('[data-bundle-variant]', pick); if (label) label.textContent = sw.getAttribute('data-title');
          total();
        });
      });
      add.addEventListener('click', function () {
        if (!window.UseitCart) return;
        var name = duo.getAttribute('data-name');
        add.classList.add('is-loading');
        window.UseitCart.add(inputs.map(function (inp) { return { id: parseInt(inp.value, 10), quantity: 1, properties: { 'Coffret': name } }; }))
          .catch(function () {}).then(function () { add.classList.remove('is-loading'); });
      });
      total();
    });
  });

  /* ---------------------------------------------------- Reviews corner form */
  $$('[data-review-open]').forEach(function (btn) {
    var wrap = document.getElementById(btn.getAttribute('aria-controls'));
    if (!wrap) return;
    var posted = wrap.querySelector('[data-review-posted], .errors');
    function set(open) { wrap.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    set(!!posted);
    if (posted) setTimeout(function () { wrap.scrollIntoView({ block: 'center' }); }, 300);
    btn.addEventListener('click', function () {
      set(!wrap.classList.contains('is-open'));
      if (wrap.classList.contains('is-open')) { var f = wrap.querySelector('input, textarea'); if (f) setTimeout(function () { f.focus(); }, 250); }
    });
  });

  /* ------------------------------------------------- Delivery dates window */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function frDay(d) { return d.getDate() === 1 ? '1er' : String(d.getDate()); }
  function frMonth(d) { return d.toLocaleDateString('fr-FR', { month: 'long' }); }
  window.UseitDates = function () {
    $$('[data-delivery-dates]').forEach(function (el) {
      var a = addBusinessDays(new Date(), parseInt(el.getAttribute('data-min'), 10) || 10);
      var b = addBusinessDays(new Date(), parseInt(el.getAttribute('data-max'), 10) || 20);
      if (el.getAttribute('data-format') === 'max') { el.textContent = 'le ' + frDay(b) + ' ' + frMonth(b); el.setAttribute('data-iso', b.toISOString().slice(0, 10)); return; }
      el.textContent = a.getMonth() === b.getMonth()
        ? 'entre le ' + frDay(a) + ' et le ' + frDay(b) + ' ' + frMonth(b)
        : 'entre le ' + frDay(a) + ' ' + frMonth(a) + ' et le ' + frDay(b) + ' ' + frMonth(b);
    });
  };
  window.UseitDates();

  /* ------------------------------------------------------------ 3. Greeting */
  if (fx.greeting && !store.sget('useit-greeted')) {
    store.sset('useit-greeted', '1');
    var h = new Date().getHours();
    var hello = h >= 18 || h < 5 ? 'Bonsoir' : 'Bonjour';
    setTimeout(function () { toast(hello + ', bienvenue chez ' + (fx.shopName || 'nous') + '.'); }, 1400);
  }

  /* ------------------------------------------------------- 7. Needle cursor */
  if (fx.needle && finePointer && !reduced) {
    var needle = document.createElement('div');
    needle.className = 'needle';
    needle.setAttribute('aria-hidden', 'true');
    needle.innerHTML = '<span class="needle__hand"></span><span class="needle__pin"></span>';
    document.body.appendChild(needle);
    document.body.classList.add('has-needle');
    var nx = -100, ny = -100, tx = -100, ty = -100, angle = 0, targetAngle = 0, over = false, spin = 0;
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var dx = e.clientX - tx, dy = e.clientY - ty;
      if (dx * dx + dy * dy > 4) targetAngle = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      tx = e.clientX; ty = e.clientY;
      var t = e.target.closest && e.target.closest('a, button, label, .card__media, .gallery__main, .u-slide__media, [data-u-track]');
      over = !!t;
      needle.classList.toggle('is-over', over);
      needle.classList.toggle('is-text', !!(e.target.closest && e.target.closest('input, textarea, select')));
    }, { passive: true });
    document.addEventListener('pointerleave', function () { tx = ty = -100; });
    (function loop() {
      nx += (tx - nx) * 0.35; ny += (ty - ny) * 0.35;
      if (over) { spin += 1.5; angle = Math.round(spin / 6) * 6; }
      else {
        var diff = ((targetAngle - angle + 540) % 360) - 180;
        angle += diff * 0.12; spin = angle;
      }
      needle.style.transform = 'translate(' + nx + 'px,' + ny + 'px) rotate(' + angle + 'deg)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------------------------------------------------------- 9. Tick-tock */
  if (fx.ticking) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ticktock';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Activer le son tic-tac');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M12 13V8.5M12 13l3 2M10 3h4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg><span class="ticktock__label">Tic-tac</span>';
    document.body.appendChild(btn);
    var ctx = null, tickTimer = 0, tock = false;
    function tick() {
      if (!ctx || document.hidden) return;
      var t = ctx.currentTime;
      var len = Math.floor(ctx.sampleRate * 0.03);
      var buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
      for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 6);
      var src = ctx.createBufferSource(); src.buffer = buf;
      var f = ctx.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = tock ? 2600 : 3400; f.Q.value = 6;
      var g = ctx.createGain(); g.gain.value = 0.35;
      src.connect(f); f.connect(g); g.connect(ctx.destination); src.start(t);
      tock = !tock;
    }
    function setOn(on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-label', on ? 'Couper le son tic-tac' : 'Activer le son tic-tac');
      clearInterval(tickTimer);
      if (on) {
        ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
        if (ctx.state === 'suspended') ctx.resume();
        tick(); tickTimer = setInterval(tick, 1000);
      }
      store.set('useit-tick', on ? '1' : '0');
    }
    btn.addEventListener('click', function () { setOn(btn.getAttribute('aria-pressed') !== 'true'); });
    // Browsers only allow sound after a gesture: resume on the first click if it was left on
    if (store.get('useit-tick') === '1') {
      btn.classList.add('is-waiting');
      document.addEventListener('pointerdown', function first(e) {
        document.removeEventListener('pointerdown', first);
        btn.classList.remove('is-waiting');
        if (!btn.contains(e.target)) setOn(true);
      });
    }
  }

  /* -------------------------------------------------------- 1. Live time */
  function drawTime() {
    var now = new Date();
    var hh = now.getHours(), mm = now.getMinutes(), ss = now.getSeconds();
    $$('[data-live-time]').forEach(function (el) {
      var hH = $('[data-hand-h]', el), hM = $('[data-hand-m]', el), hS = $('[data-hand-s]', el);
      if (hH) hH.setAttribute('transform', 'rotate(' + ((hh % 12) * 30 + mm * 0.5) + ' 50 50)');
      if (hM) hM.setAttribute('transform', 'rotate(' + (mm * 6 + ss * 0.1) + ' 50 50)');
      if (hS) hS.setAttribute('transform', 'rotate(' + ss * 6 + ' 50 50)');
      var out = $('[data-now]', el);
      if (out) out.textContent = hh + ' h ' + (mm < 10 ? '0' : '') + mm;
    });
  }
  if ($('[data-live-time]')) { drawTime(); setInterval(drawTime, 1000); }

  /* ----------------------------------------------- 2. Page tinted by dial */
  if (fx.tint) {
    var baseBg = null;
    document.addEventListener('useit:variant', function (e) {
      var section = e.detail.section;
      var label = null;
      $$('.variant-picker', section).some(function (fs) {
        var checked = $('input:checked', fs);
        var l = checked && checked.nextElementSibling;
        if (l && l.classList.contains('swatch')) { label = l; return true; }
        return false;
      });
      if (!label) return;
      var hex = hexIn(getComputedStyle(label).getPropertyValue('--swatch'));
      if (!hex) return;
      var body = document.body;
      if (!baseBg) baseBg = getComputedStyle(body).getPropertyValue('--color-bg').trim() || '#F6F1EA';
      var night = body.classList.contains('theme-night');
      body.classList.add('u-live', 'is-tinted');
      body.style.setProperty('--color-bg', 'color-mix(in srgb, ' + hex + (night ? ' 16%, ' : ' 13%, ') + baseBg + ')');
      body.style.setProperty('--tint', hex);
    });
  }

  /* ------------------------------------------------------------- 8. Loupe */
  if (fx.loupe) {
    $$('.gallery__main').forEach(function (main) {
      var lens = document.createElement('div');
      lens.className = 'loupe';
      lens.setAttribute('aria-hidden', 'true');
      main.appendChild(lens);
      var holdTimer = 0, active = false, zoom = 2.6;
      function img() { var s = $('.gallery__slide.is-active img', main); return s; }
      function show(x, y) {
        var im = img(); if (!im) return;
        var r = im.getBoundingClientRect();
        if (x < r.left || x > r.right || y < r.top || y > r.bottom) { hide(); return; }
        var mr = main.getBoundingClientRect();
        lens.style.backgroundImage = 'url("' + (im.currentSrc || im.src) + '")';
        lens.style.backgroundSize = (r.width * zoom) + 'px ' + (r.height * zoom) + 'px';
        var lx = x - r.left, ly = y - r.top, size = lens.offsetWidth || 170;
        lens.style.backgroundPosition = (-(lx * zoom - size / 2)) + 'px ' + (-(ly * zoom - size / 2)) + 'px';
        lens.style.transform = 'translate(' + (x - mr.left - size / 2) + 'px,' + (y - mr.top - size / 2) + 'px)';
        lens.classList.add('is-on'); active = true;
      }
      function hide() { lens.classList.remove('is-on'); active = false; }
      main.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') show(e.clientX, e.clientY); });
      main.addEventListener('pointerleave', hide);
      // Touch: press and hold to bring the loupe, then slide the finger
      main.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        holdTimer = setTimeout(function () { show(t.clientX, t.clientY); }, 280);
      }, { passive: true });
      main.addEventListener('touchmove', function (e) {
        if (!active) { clearTimeout(holdTimer); return; }
        e.preventDefault();
        show(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false });
      main.addEventListener('touchend', function () { clearTimeout(holdTimer); if (active) setTimeout(hide, 400); });
      main.addEventListener('click', function (e) { if (active) { e.stopPropagation(); e.preventDefault(); } }, true);
    });
  }

  /* ------------------------------------------------------- 6. Wrist try-on */
  $$('[data-tryon]').forEach(function (root) {
    var dialog = $('[data-tryon-dialog]', root);
    var watch = $('[data-tryon-watch]', root);
    var arm = $('[data-tryon-arm]', root);
    var size = $('[data-tryon-size]', root);
    var sizeOut = $('[data-tryon-size-out]', root);
    var caseMm = parseFloat(root.getAttribute('data-case')) || 40;
    var frac = parseFloat(root.getAttribute('data-frac')) || 0.82;
    var base = root.getAttribute('data-base');
    var count = parseInt(root.getAttribute('data-count'), 10) || 1;
    var WRIST_PX = 118; // wrist width drawn in the illustration (viewBox units)
    function place() {
      var circ = parseFloat(size.value);          // cm
      var wristMm = circ * 10 / 3.05;             // visible width of a wrist seen from above
      var pxPerMm = WRIST_PX / wristMm;
      var w = caseMm * pxPerMm / frac;            // image width incl. crown / lugs
      watch.style.width = (w / 600 * 100) + '%';
      sizeOut.textContent = circ.toFixed(1).replace('.', ',') + ' cm';
    }
    function setVariant(pos) {
      pos = Math.max(1, Math.min(count, pos || 1));
      watch.src = base.replace('__N__', pos);
      $$('[data-tryon-pick]', root).forEach(function (b) { b.classList.toggle('is-active', parseInt(b.getAttribute('data-tryon-pick'), 10) === pos); });
    }
    $('[data-tryon-open]', root).addEventListener('click', function () {
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      place();
    });
    $$('[data-tryon-close]', root).forEach(function (b) { b.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); }); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog && dialog.close) dialog.close(); });
    size.addEventListener('input', place);
    $$('[data-skin]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        arm.style.setProperty('--skin', b.getAttribute('data-skin'));
        $$('[data-skin]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
    $$('[data-tryon-pick]', root).forEach(function (b) {
      b.addEventListener('click', function () { setVariant(parseInt(b.getAttribute('data-tryon-pick'), 10)); });
    });
    document.addEventListener('useit:variant', function (e) { setVariant(e.detail.variant.position); });
    setVariant(parseInt(root.getAttribute('data-start'), 10) || 1);
  });

  /* ------------------------------------------------- 10. Galet stack builder */
  $$('[data-stack]').forEach(function (root) {
    var picks = $$('[data-stack-pick]', root);
    var preview = $('[data-stack-preview]', root);
    var total = $('[data-stack-total]', root);
    var count = $('[data-stack-count]', root);
    var add = $('[data-stack-add]', root);
    var max = 5;
    function refresh() {
      var sel = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; });
      preview.innerHTML = '';
      var sum = 0;
      sel.forEach(function (p, i) {
        sum += parseInt(p.getAttribute('data-price'), 10) || 0;
        var d = document.createElement('span');
        d.className = 'stack__dial';
        d.style.setProperty('--i', i);
        d.style.backgroundImage = 'url("' + p.getAttribute('data-img') + '")';
        preview.appendChild(d);
      });
      root.classList.toggle('has-picks', sel.length > 0);
      total.textContent = money(sum);
      count.textContent = sel.length;
      add.disabled = sel.length === 0;
      picks.forEach(function (p) { p.disabled = p.getAttribute('aria-pressed') !== 'true' && sel.length >= max; });
    }
    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        refresh();
      });
    });
    add.addEventListener('click', function () {
      var items = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })
        .map(function (p) { return { id: parseInt(p.getAttribute('data-id'), 10), quantity: 1, properties: { 'Accumulation': 'Oui' } }; });
      if (!items.length || !window.UseitCart) return;
      add.classList.add('is-loading');
      window.UseitCart.add(items).catch(function () {}).then(function () { add.classList.remove('is-loading'); });
    });
    refresh();
  });

  /* ------------------------------------------- Universe pages: mobile buy bar */
  $$('[data-u-sticky]').forEach(function (bar) {
    var hero = bar.closest('.u-hero');
    var range = document.getElementById('produits');
    if (!hero || !('IntersectionObserver' in window)) return;
    var heroVisible = true, rangeVisible = false;
    function update() {
      var show = !heroVisible && !rangeVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var a = bar.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('has-u-sticky', show);
    }
    new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; update(); }).observe(hero);
    if (range) new IntersectionObserver(function (e) { rangeVisible = e[0].isIntersecting; update(); }, { rootMargin: '0px 0px -30% 0px' }).observe(range);
  });

  /* --------------------------------------------------- Homme / Femme filter */
  $$('[data-gender-filter]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gender-btn]');
      if (!b) return;
      var g = b.getAttribute('data-gender-btn');
      $$('[data-gender-btn]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      $$('.grid__item', root).forEach(function (item) {
        var card = item.querySelector('[data-gender]');
        var tags = card ? card.getAttribute('data-gender') : '';
        item.hidden = !!g && tags.indexOf(g) === -1;
      });
    });
  });

  /* ------------------------------------------ 4, 5, 11. Games: quiz, wheel, surprise */
  $$('[data-games]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse($('[data-games-json]', root).textContent); } catch (e) { return; }
    var products = data.products || [];
    var U = {};
    $$('[data-universe]', root).forEach(function (el) {
      var cs = getComputedStyle(el);
      U[el.getAttribute('data-universe')] = {
        key: el.getAttribute('data-universe'),
        name: el.getAttribute('data-name'),
        tagline: el.getAttribute('data-tagline'),
        img: el.getAttribute('data-img'),
        url: el.getAttribute('data-url'),
        bg: cs.getPropertyValue('--u-bg').trim(),
        ink: cs.getPropertyValue('--u-ink').trim(),
        accent: cs.getPropertyValue('--u-accent').trim()
      };
    });
    var keys = Object.keys(U);

    // Tabs
    var tabs = $$('[data-game-tab]', root), panels = $$('[data-game-panel]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-game-tab');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-game-panel') !== id; });
      });
    });

    function variantsOf(key, maxPrice) {
      var out = [];
      products.forEach(function (p) {
        if (key && p.k !== key) return;
        p.v.forEach(function (v) {
          if (v.a && (!maxPrice || v.p <= maxPrice)) out.push({ product: p, variant: v });
        });
      });
      return out;
    }
    function paint(el, u) {
      el.style.setProperty('--u-bg', u.bg);
      el.style.setProperty('--u-ink', u.ink);
      el.style.setProperty('--u-accent', u.accent);
    }
    function watchCard(hit, extraProps, hidden) {
      if (!hit) return '<p class="game__empty">Cette montre arrive bientôt : revenez vite.</p>';
      var v = hit.variant, p = hit.product;
      var title = p.t + (v.t && v.t !== 'Default Title' ? ' · ' + v.t : '');
      return '<div class="game__watch' + (hidden ? ' is-hidden-watch' : '') + '">' +
        '<a class="game__watch-img" href="' + v.u + '"><img src="' + (v.i || p.i) + '" alt="" loading="lazy" width="300" height="375"></a>' +
        '<div><p class="game__watch-title">' + title + '</p><p class="game__watch-price">' + money(v.p) + '</p>' +
        '<button type="button" class="btn u-btn btn--small" data-game-add="' + v.id + '"' + (extraProps ? " data-props='" + JSON.stringify(extraProps).replace(/'/g, '&#39;') + "'" : '') + '>Ajouter au panier</button></div></div>';
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-game-add]');
      if (!b || !window.UseitCart) return;
      var props = b.getAttribute('data-props');
      var item = { id: parseInt(b.getAttribute('data-game-add'), 10), quantity: 1 };
      if (props) item.properties = JSON.parse(props);
      b.classList.add('is-loading');
      window.UseitCart.add([item]).catch(function () {}).then(function () { b.classList.remove('is-loading'); });
    });

    // ---- 4. Quiz
    var quiz = $('[data-quiz]', root);
    if (quiz) {
      var steps = $$('[data-quiz-step]', quiz), result = $('[data-quiz-result]', quiz), bar = $('[data-quiz-bar]', quiz);
      var score = {}, step = 0;
      function showStep(i) {
        steps.forEach(function (s, j) { s.hidden = j !== i; });
        bar.style.width = (i / steps.length * 100) + '%';
      }
      function finish() {
        var best = 0, leaders = [];
        keys.forEach(function (k) { var s = score[k] || 0; if (s > best) { best = s; leaders = [k]; } else if (s === best) leaders.push(k); });
        var u = U[pick(leaders.length ? leaders : keys)];
        steps.forEach(function (s) { s.hidden = true; });
        bar.style.width = '100%';
        paint(result, u);
        result.innerHTML =
          '<div class="game__result-media"><img src="' + u.img + '" alt="" width="1200" height="1500"></div>' +
          '<div class="game__result-body"><p class="eyebrow u-eyebrow">Ton univers</p><p class="game__result-name">' + u.name + '</p>' +
          '<p class="game__result-tagline">' + u.tagline + '</p>' + watchCard(pick(variantsOf(u.key)) || null) +
          '<div class="game__result-actions"><a class="u-link" href="' + u.url + '">Entrer dans l\'univers</a>' +
          '<button type="button" class="u-link" data-quiz-share>Partager</button><button type="button" class="u-link" data-quiz-restart>Recommencer</button></div></div>';
        result.hidden = false;
        result.setAttribute('data-name', u.name);
      }
      quiz.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-quiz-option]');
        if (opt) {
          String(opt.getAttribute('data-quiz-option')).split(',').forEach(function (pair) {
            var kv = pair.split(':'); if (kv[0]) score[kv[0]] = (score[kv[0]] || 0) + (parseInt(kv[1], 10) || 1);
          });
          step += 1;
          if (step >= steps.length) finish(); else showStep(step);
          return;
        }
        if (e.target.closest('[data-quiz-restart]')) { score = {}; step = 0; result.hidden = true; showStep(0); return; }
        if (e.target.closest('[data-quiz-share]')) {
          var text = 'Mon univers Useit : ' + result.getAttribute('data-name') + '. Et toi ?';
          if (navigator.share) navigator.share({ title: document.title, text: text, url: location.href }).catch(function () {});
          else if (navigator.clipboard) navigator.clipboard.writeText(text + ' ' + location.href).then(function () { toast('Lien copié'); });
        }
      });
      showStep(0);
    }

    // ---- 5. Wheel
    var wheel = $('[data-wheel]', root);
    if (wheel) {
      var disc = $('[data-wheel-disc]', wheel), spinBtn = $('[data-wheel-spin]', wheel), wres = $('[data-wheel-result]', wheel);
      var order = $$('[data-wheel-seg]', wheel).map(function (s) { return s.getAttribute('data-wheel-seg'); });
      var turn = 0, spinning = false, seg = 360 / order.length;
      disc.style.background = 'conic-gradient(' + order.map(function (k, j) { return (U[k] ? U[k].bg : '#ccc') + ' ' + (j * seg) + 'deg ' + ((j + 1) * seg) + 'deg'; }).join(', ') + ')';
      spinBtn.addEventListener('click', function () {
        if (spinning) return;
        spinning = true; spinBtn.disabled = true; wres.hidden = true;
        var i = Math.floor(Math.random() * order.length);
        var target = 360 - (i * seg + seg / 2) + (Math.random() - 0.5) * seg * 0.6;
        turn = Math.ceil(turn / 360) * 360 + 360 * (reduced ? 1 : 5) + target;
        disc.style.transform = 'rotate(' + turn + 'deg)';
        setTimeout(function () {
          var u = U[order[i]];
          paint(wres, u);
          var code = wheel.getAttribute('data-code');
          wres.innerHTML = '<p class="eyebrow u-eyebrow">La roue a choisi</p><p class="game__result-name">' + u.name + '</p>' +
            watchCard(pick(variantsOf(u.key)) || null) +
            (code ? '<p class="game__code">Ton code : <strong>' + code + '</strong></p>' : '') +
            '<a class="u-link" href="' + u.url + '">Entrer dans l\'univers</a>';
          wres.hidden = false; spinning = false; spinBtn.disabled = false;
        }, reduced ? 600 : 4300);
      });
    }

    // ---- 11. Surprise
    var sur = $('[data-surprise]', root);
    if (sur) {
      var choice = { k: '', max: 0 };
      sur.addEventListener('click', function (e) {
        var c = e.target.closest('[data-sur-k]'), m = e.target.closest('[data-sur-max]');
        if (c) { choice.k = c.getAttribute('data-sur-k'); $$('[data-sur-k]', sur).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); }); }
        if (m) { choice.max = parseInt(m.getAttribute('data-sur-max'), 10) || 0; $$('[data-sur-max]', sur).forEach(function (x) { x.setAttribute('aria-pressed', x === m ? 'true' : 'false'); }); }
        if (e.target.closest('[data-sur-go]')) {
          var pool = variantsOf(choice.k, choice.max);
          var out = $('[data-sur-result]', sur);
          if (!pool.length) { out.innerHTML = '<p class="game__empty">Aucune montre ne correspond : essayez un autre budget.</p>'; out.hidden = false; return; }
          var hit = pick(pool);
          var u = U[hit.product.k] || U[keys[0]];
          paint(out, u);
          out.classList.remove('is-open');
          out.innerHTML = '<div class="gift" aria-hidden="true"><span class="gift__lid"></span><span class="gift__box"></span></div>' +
            '<p class="game__result-name">Votre surprise est prête</p><p class="game__result-tagline">Une montre ' + u.name + ', choisie pour vous.</p>' +
            '<div class="game__result-actions">' +
            '<button type="button" class="btn u-btn btn--small" data-game-add="' + hit.variant.id + '" data-props=\'' + JSON.stringify({ 'Coffret surprise': 'Choisie par ' + (fx.shopName || 'la maison'), 'Univers': u.name }).replace(/'/g, '&#39;') + '\'>Ajouter la surprise</button>' +
            '<button type="button" class="u-link" data-sur-reveal>Découvrir la montre</button></div>' +
            '<div data-sur-watch hidden>' + watchCard(hit) + '</div>' +
            '<p class="game__note">Le nom de la montre reste masqué dans le panier ; il apparaît au paiement.</p>';
          out.hidden = false;
          setTimeout(function () { out.classList.add('is-open'); }, 60);
        }
        if (e.target.closest('[data-sur-reveal]')) { var w = $('[data-sur-watch]', sur); if (w) w.hidden = false; }
      });
    }
  });
})();

/* « 2 achetées = 2 offertes »: keep the price per watch in sync with the chosen variant */
document.addEventListener('useit:variant', function (e) {
  var ob = document.querySelector('[data-offer-badge]'), v = e.detail && e.detail.variant;
  if (!ob || !v || !window.theme || !theme.formatMoney) return;
  var buy = +ob.getAttribute('data-buy'), full = +ob.getAttribute('data-full');
  ob.querySelector('[data-offer-pack]').textContent = theme.formatMoney(v.price * buy);
  ob.querySelector('[data-offer-each]').textContent = theme.formatMoney(Math.floor(v.price * buy / full));
});
